import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import BasicButton from '../../Components/Button_Basic';
import Input from '../../Components/Input_Basic';
import FormGroup from '../../Components/Form_Group';
import BasicModal from '../../Components/Modal_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridModal from '../../Components/Modal_Grid';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';

function SM10050(props) {
    React.useEffect(() => {
        document.title = '출하현황';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '영업관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>출하현황</strong>" +
            '</h1>';
    }, []);
    const gridRef = React.useRef();
    const [searchDate, setSearchDate] = React.useState(new Date());
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    //상세보기 팝업
    const [modalToggle, setModalToggle] = React.useState(false);
    // const autoGroupColumnDef = React.useMemo(() => {
    //   // 그룹 설정
    //   return {
    //     headerName:
    //       props.lanData.length > 0
    //         ? props.lanData.filter(
    //             (f) => f.lanId === "Col_CustNm" && f.lanType === "COL"
    //           )[0].lanName
    //         : "",
    //     field: "custNm",
    //     minWidth: 200,
    //     cellRenderer: "agGroupCellRenderer",
    //     cellRendererParams: {
    //       checkbox: true,
    //     },
    //   };
    // }, []);
    const autoGroupColumnDef = React.useMemo(() => {
        // 그룹 설정
        return {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
            cellRenderer: 'agGroupCellRenderer',
            cellRendererParams: {
                checkbox: true,
            },
        };
    }, []);
    const AuthGroupSettingClicked = (_data) => {
        if (props.selectedRowData.length == 0) {
            props.GetPrintStockData();

            return false;
        } else {
            props.GetPrintStockData();

            setModalToggle(true);
        }
    };
    const rowGroupPanelShow = 'always';
    const groupDefaultExpanded = 1;
    const columnDefs = [
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 200,
            hide: true,
            rowGroup: true,
            // enableRowGroup: true,
            // cellRendererParams: {
            //   checkbox: true,
            // },
        },
        //상태값
        {
            field: 'stusCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StatusName' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            // rowGroup: true,
            // enableRowGroup: true,

            cellRenderer: Commons.CustomHeaderRenderer,
        },
        //납기일자
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            enableRowGroup: true,
        },
        //출하일자
        {
            field: 'delivDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ShipmentDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            enableRowGroup: true,
        },
        //지시자
        {
            field: 'delivUser',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivUser' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            enableRowGroup: true,
        },
        //출하지시일자
        {
            field: 'delivOrderDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ShipOrderDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            enableRowGroup: true,
        },
        //지시자
        {
            field: 'delivOrderUser',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderUser' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            enableRowGroup: true,
        },
        //납품확인 지시자
        {
            field: 'delivCheckUser',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivCheckUser' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            enableRowGroup: true,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 200,
            enableRowGroup: true,
        },
        //수량
        {
            field: 'delivQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },
        //단가
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },
        //금액
        {
            field: 'itemCost',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },
        //VAT
        {
            field: 'itemVat',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVat' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },

        //적요
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_RemarkDtl' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //VAT여부
        {
            field: 'itemVatYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVatYn' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'center' },
            minWidth: 100,
        },

        //단위
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '',
            aggFunc: 'sum',
            minWidth: 90,
        },
        //주문번호
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            enableRowGroup: true,
        },

        //출하지시번호
        {
            field: 'delivOrderNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            hide: true,
        },
        //출하번호
        {
            field: 'delivNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            hide: true,
        },

        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            hide: true,
        },
        //거래처코드
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            hide: true,
        },
        // //수주번호
        // {
        //   field: "soNo",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_SoNo" && f.lanType === "COL"
        //         )[0].lanName
        //       : "",
        //   minWidth: 110,
        // },
    ];
    const lotColumnDef = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 50,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            valueGetter: 'node.rowIndex + 1',
        },
        //LOT No
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        // //품목코드
        // {
        //   field: "itemCd",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
        //         )[0].lanName
        //       : "",
        // },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //수량
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    const onCellClicked = (e) => {
        const selected = e.data;
        props.setInputs({
            ...props.inputs,
            plantCd: selected ? selected.plantCd : '',
            custNm: selected ? selected.custNm : '',
            delivOrderDt: selected ? selected.delivOrderDt : '',
            delivOrderNo: selected ? selected.delivOrderNo : '',
            delivQty: selected ? selected.delivQty : '',
            itemNm: selected ? selected.itemNm : '',
            soNo: selected ? selected.soNo : '',
            delivDt: selected ? selected.delivDt : '',
            itemCd: selected ? selected.itemCd : '',
            custCd: selected ? selected.custCd : '',
            filePath: selected ? selected.filePath : '',
        });
    };

    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                    }}
                >
                    <DatePicker
                        className={'datepicker-custom-input'}
                        style={{ width: '120px', marginRight: '5px' }}
                        selected={props.startDate}
                        onChange={(e) => {
                            props.setStartDate(e);
                        }}
                    />
                    ~
                    <DatePicker
                        className={'datepicker-custom-input'}
                        style={{
                            width: '120px',
                            marginLeft: '5px',
                            marginRight: '10px',
                        }}
                        selected={props.endDate}
                        onChange={(e) => {
                            props.setEndDate(e);
                        }}
                    />
                    수주/출하지시번호
                    <Input
                        type={'text'}
                        value={props.orderNumber}
                        onChange={(e) => {
                            props.setOrderNumber(e.target.value);
                        }}
                        onClick={() => {}}
                        onKeyDown={() => {}}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {/* 인쇄1 */}
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Print' && f.lanType === 'BTN')[0].lanName
                                : '' //인쇄
                        }
                        onClick={(e) => {
                            props.Print();
                        }}
                    />
                    {/* 인쇄2 */}
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Print1' && f.lanType === 'BTN')[0]
                                      .lanName
                                : '' //인쇄1
                        }
                        onClick={(e) => {
                            props.Print1();
                        }}
                    />
                    {/* 상세보기 */}
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Detail_Search' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        onClick={(e) => {
                            AuthGroupSettingClicked(e);
                        }}
                    />
                    {/* 납품확인 */}
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Btn_Delivery_Check' && f.lanType === 'BTN'
                                  )[0].lanName
                                : ''
                        }
                        onClick={(e) => {
                            props.CreateDelivStatusfirm();
                        }}
                    />
                    <AuthGroupButton
                        pageName="SM10050"
                        target="G01"
                        // refreshFunc={() => {
                        //   props.Init();
                        // }}
                        refreshNone="none"
                        selectFunc={() => {
                            props.Init();
                        }}
                    />
                </div>
            </Card>{' '}
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                <AgGridReact
                    ref={gridRef}
                    // animateRows={true}
                    columnDefs={columnDefs}
                    // groupDefaultExpanded={groupDefaultExpanded}
                    // rowGroupPanelShow={rowGroupPanelShow}
                    // groupIncludeTotalFooter={true}
                    autoGroupColumnDef={autoGroupColumnDef}
                    // groupSelectsChildren={true}
                    // groupSelectsFiltered={true}
                    // suppressAggFuncInHeader={true}
                    // defaultColDef={{
                    //   flex: 1,
                    //   editable: false,
                    //   resizable: true,
                    //   sortable: true,
                    //   filter: true,
                    //   floatingFilter: true,
                    // }}
                    // onCellValueChanged={(e) =>
                    //   GridFunctions.onCellValueChanged(
                    //     e,
                    //     gridRef,
                    //     props.setChangedRowData
                    //   )
                    // }
                    rowSelection={'multiple'}
                    groupSelectsChildren={true}
                    suppressRowClickSelection={true}
                    suppressAggFuncInHeader={true}
                    rowData={props.rowData}
                    // rowMultiSelectWithClick={true}
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                    onCellClicked={onCellClicked}
                />
            </div>
            {/* 상세보기 */}
            {modalToggle && (
                <GridModal
                    conditions={[]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setModalToggle(false)}
                    gridColumn={lotColumnDef}
                    gridRowData={props.stockData}
                    notButton="9"
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                itemCd: e[i].itemNm,
                                lotNo: e[i].lotNo,
                                stockQty: e[i].stockQty,
                                whNm: e[i].whNm,
                            });
                        }
                        props.setSelectedModalData(data);
                    }}
                />
            )}
        </div>
    );
}

export default SM10050;
